import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

function Body({ children, scrollable, overflow, maxHeight, }) {
    return (jsx("div", { style: {
            overflow,
            maxHeight,
        }, className: cns('modal--body', {
            'modal--body--scrollable': scrollable,
        }), children: children }));
}
Body.defaultProps = {
    children: null,
    scrollable: null,
    maxHeight: null,
    overflow: null,
};

export { Body as default };
